<h4 style="text-align: center">{{ widget.description }}</h4>
<ul class="listContainer" *ngIf="widget.data">
  <p-scrollPanel [style]="{ width: '100%', height: '23em' }">
    <li *ngFor="let data of widget.data" draggable="true" class="listData">{{ data }}</li>
  </p-scrollPanel>
</ul>
